<ng-container [ngSwitch]="status">
  <div class="alert alert-success text-center w-100 h-auto py-5" *ngSwitchCase="1">
    <p>
      {{ 'Account activated successfully' | translate }}<br />
      {{ 'You will be brought back to the homepage after ' | translate }}<span>{{ countdownSec$ }}s<br /></span> {{ 'Or' | translate }}<br />
      [<a [routerLink]="['/home']">{{ 'Click here to return back to the home page' | translate }}</a>]
    </p>
  </div>

  <div class="alert alert-danger text-center w-100 h-auto py-5" *ngSwitchCase="-1">
    <p>
      {{ 'Account activated failed' | translate }}<br />
      [<a [routerLink]="['/home']">{{ 'Click here to return back to the home page' | translate }}</a>]
    </p>
  </div>
</ng-container>
